<script>
    import Box from "../components/Box.svelte";
    import MatrixText from "../components/MatrixText.svelte";
    import config from './../config'
    import { link } from "svelte-spa-router";
</script>


<svelte:head>
	<title>Damien ROCH | Skills & Experiences</title>
</svelte:head>

<Box>
    <h1>
        <i class="fa-solid fa-bars-progress" /> Experiences &
        <strong><MatrixText value="Skills" /></strong>
    </h1>

    <div class="columns">
        <div class="column ">
            <p class="mb-4">
                For 15 years I have been working agencies and startups to create
                innovative and robust web products.
            </p>
            <p class="mb-4">
                The main area of my expertise is backend development, with
                <code>PHP/Symfony</code> <code>(No)SQL</code> <code>APIs</code> in cloud environment for fast and
                scalable web apps.<br />
                I also have frontend developer skills and experiences with <code>JS/React/Svelte</code>,
                <code>(S)CSS</code>, <code>Webpack</code>, <code>PWA</code> and others.
            </p>
            <p class="mb-4">
                Visit my <a
                href="{config.linkedinUrl}"
                class="link"
                rel="nofollow noopener"
                target="_blank"
            >LinkedIn Profile</a> for more infos or just <a href="/contact" use:link class="link">contact me</a>.
            </p>
        </div>
        <div class="column is-one-third">
            <p>
                <a
                    href="{config.linkedinUrl}"
                    class="social"
                    rel="nofollow noopener"
                    target="_blank"
                >
                    <i class="fa-brands fa-linkedin fa-2xl fa-fw" style="color:#1170ad"/> LinkedIn
                </a>
                <a
                    href="{config.githubUrl}"
                    class="social"
                    rel="nofollow noopener"
                    target="_blank"
                >
                    <i class="fa-brands fa-github fa-2xl fa-fw" style="color:#fff"/> Github
                </a>
                <a
                    href="{config.stackoverflowUrl}"
                    class="social"
                    rel="nofollow noopener"
                    target="_blank"
                >
                    <i class="fa-brands fa-stack-overflow fa-2xl fa-fw" style="color:#e8770f"/> Stackoverflow
                </a>
            </p>
        </div>
    </div>
</Box>

<style>
    .social {
        border:3px solid  rgba(255, 255, 255, 0.5);
        border-radius: 25px;
        display: block;
        padding: 16px 8px;
        margin-bottom: 12px;
        text-align: center;
        font-size:.9rem;
        color:#ababab;
        font-weight: bold;
    }
</style>
